import { connect } from "react-redux";
import MiscBar from "./MiscBar";

import { getDefaultStoreUrl } from "../../state/modules/regionalStore";
import get from "lodash/get";

const getTopBarMVTStatus = state =>
  get(state, `features["emf-82-desktop-hide-top-grey-bar"].hidden`);

function mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state),
    headerTopBarHidden: getTopBarMVTStatus(state)
  };
}

export default connect(mapStateToProps)(MiscBar);
